import styled from "styled-components";
import { NumericFormat } from "react-number-format";
import { TEXT_PRIMARY, ERROR_AMOUNT, COOL_GREY } from "@/constants/colors";
import { FONT_SIZE_BASE, TITLE, BODY, REGULAR, SEMI_BOLD } from "@/constants/fonts";

export const LineItemDescription = styled.div`
  color: ${TEXT_PRIMARY};
  font-family: ${TITLE};
  font-weight: ${SEMI_BOLD};
  font-size: ${FONT_SIZE_BASE};
  text-align: left;
  margin: 0px;
`;

export const LineItemSubDescription = styled.div`
  color: ${TEXT_PRIMARY};
  font-family: ${BODY};
  font-weight: ${REGULAR};
  font-size: ${FONT_SIZE_BASE};
  text-align: left;
  margin: 0px;
`;

export const AmountError = styled.div`
  color: ${ERROR_AMOUNT};
  font-family: ${BODY};
  font-weight: ${REGULAR};
  font-size: ${FONT_SIZE_BASE};
  text-align: center;
  margin: 4px 0 0 0;
`;

export const CurrencyInput = styled(NumericFormat)`
  && {
    text-align: right;
    width: 120px;
    padding: 12px 16px;
    border-radius: 2px;
    border: 1px solid ${(props) => (props.$isValid ? COOL_GREY : ERROR_AMOUNT)};
  }
`;
